const GSM_BASIC_CHARACTERS = new Set(
  Array.from(
    "@\u00a3$\u00a5\u00e8\u00e9\u00f9\u00ec\u00f2\u00c7\n\u00d8\u00f8\r\u00c5\u00e5\u0394_\u03a6\u0393\u039b\u03a9\u03a0\u03a8\u03a3\u0398\u039e\u00c6\u00e6\u00df\u00c9 !\"#\u00a4%&'()*+,-./0123456789:;<=>?\u00a1ABCDEFGHIJKLMNOPQRSTUVWXYZ\u00c4\u00d6\u00d1\u00dc\u00a7\u00bfabcdefghijklmnopqrstuvwxyz\u00e4\u00f6\u00f1\u00fc\u00e0",
  ),
);

const GSM_EXTENDED_CHARACTERS = new Set(
  Array.from("\f^{}\\[~]|\u20ac"),
);

const EMOJI_COMPONENT_PATTERN =
  /[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}\u200d\ufe0f\u20e3]/u;

const TEMPLATE_PLACEHOLDERS = {
  CompanyName: "RueBaRue Rentals",
  FirstName: "Alexandra",
  LastName: "Montgomery",
  Email: "guest@example.com",
  PropertyId: "PROPERTY-1234",
  CheckIn: "Jul 20, 2026",
  CheckOut: "Jul 27, 2026",
  PhoneNumber: "(555) 555-0123",
  ReservationId: "ABC123456",
  NativeId: "ABC123456",
  PropertyAddress: "123 Beach Avenue, Miami, FL 33101",
  DoorCode: "123456",
  WifiName: "Beach House WiFi",
  WifiPassword: "welcome123",
  CheckInTime: "4:00 PM",
  CheckOutTime: "10:00 AM",
  Source: "Direct Booking",
  PropertyGuideLink:
    "https://guide.ruebarue.com/guestbook/1234567890123456",
  DestinationGuideLink:
    "https://guide.ruebarue.com/destination/1234567890123456",
  FiveStarLink: "https://guide.ruebarue.com/review/1234567890123456",
  FiveStarReview: "https://guide.ruebarue.com/review/1234567890123456",
  GuestCheckIn:
    "https://guide.ruebarue.com/check-in/1234567890123456",
  GuestCheckOut:
    "https://guide.ruebarue.com/check-out/1234567890123456",
  EarlyCheckIn:
    "https://guide.ruebarue.com/early-check-in/1234567890123456",
  LateCheckOut:
    "https://guide.ruebarue.com/late-check-out/1234567890123456",
};

const DEFAULT_CUSTOM_PLACEHOLDER = "Property information";

const PASTE_REPLACEMENTS = {
  "\u201c": '"',
  "\u201d": '"',
  "\u2018": "'",
  "\u2019": "'",
  "\u2014": "-",
  "\u2013": "-",
  "\u2026": "...",
};

const normalizeVariableKey = (key = "") =>
  String(key).replace(/^\[|\]$/g, "");

const resolveTemplateVariables = (message, variables = {}) => {
  const normalizedVariables = Object.entries(variables || {}).reduce(
    (result, [key, value]) => ({
      ...result,
      [normalizeVariableKey(key)]: value,
    }),
    {},
  );

  return String(message || "").replace(/\[([^\]\r\n]+)\]/g, (token, key) => {
    if (
      Object.prototype.hasOwnProperty.call(normalizedVariables, key) &&
      normalizedVariables[key] !== undefined &&
      normalizedVariables[key] !== null &&
      normalizedVariables[key] !== ""
    ) {
      return String(normalizedVariables[key]);
    }

    if (/^Survey-\d+$/.test(key)) {
      return "https://guide.ruebarue.com/survey/123/1234567890123456";
    }

    return TEMPLATE_PLACEHOLDERS[key] || DEFAULT_CUSTOM_PLACEHOLDER;
  });
};

const getGsmCharacterUnits = (message) => {
  let units = 0;

  for (const character of message) {
    if (GSM_BASIC_CHARACTERS.has(character)) {
      units += 1;
    } else if (GSM_EXTENDED_CHARACTERS.has(character)) {
      units += 2;
    } else {
      return null;
    }
  }

  return units;
};

const hasNonEmojiSpecialCharacters = (message) =>
  Array.from(message).some(
    (character) =>
      !GSM_BASIC_CHARACTERS.has(character) &&
      !GSM_EXTENDED_CHARACTERS.has(character) &&
      !EMOJI_COMPONENT_PATTERN.test(character),
  );

const getMessageCount = (units, singleMessageLimit, multipartMessageLimit) => {
  if (units === 0) return 0;
  if (units <= singleMessageLimit) return 1;
  return Math.ceil(units / multipartMessageLimit);
};

export const normalizeSmsPaste = (text = "") =>
  String(text).replace(/[\u2018\u2019\u201c\u201d\u2013\u2014\u2026]/g, (character) =>
    PASTE_REPLACEMENTS[character],
  );

export const analyzeSmsMessage = (message = "", variables = {}) => {
  const estimatedMessage = resolveTemplateVariables(message, variables);
  const gsmUnits = getGsmCharacterUnits(estimatedMessage);
  const unicodeDetected = gsmUnits === null;
  const specialCharacterWarningDetected =
    unicodeDetected && hasNonEmojiSpecialCharacters(estimatedMessage);
  const encoding = unicodeDetected ? "Unicode" : "GSM-7";
  const messageUnits = unicodeDetected ? estimatedMessage.length : gsmUnits;
  const messageCount = unicodeDetected
    ? getMessageCount(messageUnits, 70, 67)
    : getMessageCount(messageUnits, 160, 153);

  let status = "Good";
  if (messageCount >= 3) {
    status = "Very Long";
  } else if (messageCount === 2) {
    status = "Long";
  }

  return {
    messageCount,
    encoding,
    status,
    unicodeDetected,
    specialCharacterWarningDetected,
  };
};
